var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"approval-bpmn",style:(_vm.containerStyle)},[_c('div',{ref:"canvas",staticClass:"approval-bpmn__canvas",style:(_vm.containerStyle)}),(_vm.errorMsg)?_c('div',{staticClass:"approval-bpmn__error"},[_vm._v(_vm._s(_vm.errorMsg))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }